import { z } from "zod";

/**
 * CodeNodeSchema - Content Schema for Code Node
 *
 * Code nodes are block-level containers for code snippets.
 *
 * Nesting constraints:
 * - ✅ children can ONLY contain: TextNode (Lexical's CodeHighlightNode maps to TextNode)
 * - ❌ Does NOT allow: StockNode, TagNode (Lexical prevents decorator nodes in code blocks)
 *
 * Note: Lexical uses CodeHighlightNode (special TextNode) inside CodeNode.
 * Content Schema maps this to TextNode with text content.
 */
export const CodeNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("code"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  language: z.string().optional(), // Programming language (e.g., "typescript", "python")
  children: z.array(z.any()), // Array of TextNode children only
}).strict();

export type CodeNode = z.infer<typeof CodeNodeSchema>;
